import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Fade from 'react-reveal/Fade';
import '../custom-build/steps.scss';

import buttonarrow from '../../assets/images/button-arrow.svg';
import person from '../../assets/images/person.svg';
import shippingimg from '../../assets/images/shipping.svg';

class ShippingView extends Component {
    render() {
        return (
          <div className="home-content steps-content">
              <div className="homeleftcontent steps-left">
                <Fade right>
                    <h4>Generate packing slips and ship the order to your customer. Manage shipping to multiple locations for complete or partial order quantities.</h4>
                </Fade>
                <Fade right>
                    <p className="steps-text">Integrations with FedEx, UPS, and Endicia to print shipping labels, validate addresses, and generate tracking numbers.</p>
                </Fade>
                <Fade right>
                    <div className="button-section">
                        <Link to="/production" className="theme-btn backarrow-btn"><img alt="" src={buttonarrow} /></Link>
                        <Link to="/Invoicing" className="theme-btn">Invoicing <img alt="" src={buttonarrow} /></Link>
                    </div>
                </Fade>
                <div className="bottom-person">
                    <Fade right>
                        <img alt="Customer Portal" src={person} />
                        <div className="person-right">
                            <h3>Track shipment</h3>
                            <small>Customer Portal</small>
                        </div>
                    </Fade>
                </div>
              </div>
              <div className="homerightcontent">
                  <Fade right>
                      <img alt="Custom Built" className="w-100 shipping-img" src={shippingimg} />
                  </Fade>
              </div>
          </div>
        )
    }
}

export default ShippingView
